export const environment = {
    production: false,
    apiUrl: 'https://api-dev.nonprod.cloud.univa.health/api/v1/',
    baseApiUrl: 'https://api-dev.nonprod.cloud.univa.health/api/',
    sentryDsnAngular: "https://07a6230385bb9af12f192f44a35860f4@o4508720975642624.ingest.de.sentry.io/4512239041773648",
    sentryTracesSampleRate: 1.0,
    envName: 'development',
    sensitiveDataMaskingEnabled: false
};
